import { createContext, useContext, useState, useEffect, useRef } from 'react';

const PersonContext = createContext();

export const PersonProvider = ({ children }) => {
  const [person, setPerson] = useState(null);
  const token = sessionStorage.getItem('token');
  const host = process.env.REACT_APP_RESTAPI_URL;

  const isLoading = useRef(false);

  useEffect(() => {
    //console.log(`현재 시간: ${new Date().toISOString()}`);
    //console.log(`isLoading: ${isLoading.current} user: ${user} token: ${token}`);
    if (!isLoading.current && !person && token) { // 로딩 중이 아닐 때만 실행
      isLoading.current = true; // isLoading를 true로 설정
      //현재 시간을 밀리세컨드까지 로그로 남기기
      const url = `${host}/oauth/person`;
      console.log(`Fetching person data from URL: ${url}`); // URL 로그 출력

      fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }).then((response) => {
          if (!response.ok) {
            // 응답이 성공적이지 않을 경우 에러 처리
            return response.json().then((errorData) => {
              throw new Error(errorData.message || '알 수 없는 오류가 발생했습니다.');
            });
          }
        
          return response.json();
        })
        .then((data) => {
          console.log(`현재 시간: ${new Date().toISOString()}`);
          console.log('사용자 정보:', data); // 사용자 정보를 콘솔에 표시합니다.
          setPerson(data);
        })
        .catch((error) => {
          console.error('Error fetching user data:', error.message);
          alert(error.message); // 에러 메시지를 alert로 표시
          sessionStorage.removeItem('token');
          setPerson(null);
        })
        .finally(() => {
          isLoading.current = false;
        });
    }
  }, [person, host, token]);

  const logout = () => {
    if (isLoading.current) return; // 로딩 중일 때 로그아웃 차단
    sessionStorage.removeItem('token');
    setPerson(null);
  };

  return (
    <PersonContext.Provider value={{ person, setPerson, logout, isLoading }}>
      {children}
    </PersonContext.Provider>
  );
};

export const usePerson = () => useContext(PersonContext);
export { PersonContext };